import src from "IMAGE";
export default { src, width: 3264, height: 514, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ADNlAH44cACMNmwAhzVpAIQ3bgCKOHEAjTRpAIMtWgBwlbwJEllv+DUAAAAASUVORK5CYII="};
